"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.closeClaimRecordInstruction = void 0;
const api_1 = require("./api");
/**
 * Generate instruction to close claimRecord.
 * This function loads data from blockchain when not all parameters are provided.
 *
 * @type {Object} args - Arguments on instruction creation
 * @param param {IncentivesDistributionProgram} args.program - anchor program instance
 * @param param {PublicKey} args.treasuryAccount - treasury account
 * @param param {PublicKey} args.adminAuthority - admin authority [SIGNER] (when not provided loaded from treasuryAccount data)
 * @param param {PublicKey} args.claimRecordAccount - claim record account (when not provided, it will be calculated from claimRecordAuthority)
 * @param param {PublicKey} args.claimRecordAuthority - claim record authority (used to calculate claimRecordAccount address)
 * @param param {PublicKey} args.rentCollector - on closing account the rent is payed back here (default: provider wallet address)
 * @type {Object} return - Return data of generated instruction
 * @return {PublicKey} return.address - Address of the closed claim record
 * @return {TransactionInstruction} return.instruction - Instruction to close claimRecord
 */
async function closeClaimRecordInstruction({ program, treasuryAccount, adminAuthority, claimRecordAccount, claimRecordAuthority, rentCollector = program.provider.publicKey, }) {
    if (!claimRecordAccount && !claimRecordAuthority) {
        throw new Error('Either claimRecordAccount or claimRecordAuthority must be provided');
    }
    else if (!claimRecordAccount && treasuryAccount) {
        const { address } = (0, api_1.claimRecordAddress)({
            programId: program.programId,
            treasury: treasuryAccount,
            authority: claimRecordAuthority,
        });
        claimRecordAccount = address;
    }
    else if (!claimRecordAccount) {
        throw new Error('Cannot get claim record account address, provide claim-record-authority and treasury-account');
    }
    if (!treasuryAccount) {
        const claimRecordData = await (0, api_1.claimRecord)({
            program,
            address: claimRecordAccount,
        });
        treasuryAccount = claimRecordData.treasuryAccount;
    }
    if (!adminAuthority) {
        const treasuryData = await (0, api_1.treasury)({ program, address: treasuryAccount });
        adminAuthority = adminAuthority || treasuryData.adminAuthority;
    }
    const instruction = await program.methods
        .closeClaimRecord()
        .accountsStrict({
        claimRecordAccount,
        treasuryAccount,
        adminAuthority,
        rentCollector,
    })
        .instruction();
    return { instruction, address: claimRecordAccount };
}
exports.closeClaimRecordInstruction = closeClaimRecordInstruction;
//# sourceMappingURL=closeClaimRecordInstruction.js.map